import {
    AxnCompany,
    AxnRelyingParty,
    SimpleAxnRpServiceWorkflow,
    SimpleAxnWorkflow
} from "@idw-types/data/reference-data/axn";
import { SimpleDeployedPolicyConfig } from "@idw-types/data/reference-data/axn/simple-deployed-policy-config";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { PolicyComponentAssociatedPolicy } from "@idw-types/policy-component-associated-policy";
import { toObject } from "@utils/object-util";

const getAxnAdminWorkflowsMap = (axnWorkflows: Array<SimpleAxnWorkflow>, axnRpServiceWorkflowIDs: Array<string>) => {
    return axnWorkflows.reduce((workflowsAcc, axnAdminWorkflow) => {
        if (axnRpServiceWorkflowIDs.includes(axnAdminWorkflow.id)) {
            workflowsAcc[axnAdminWorkflow.id] = axnAdminWorkflow;
        }

        return workflowsAcc;
    }, {} as { [id: string]: SimpleAxnWorkflow });
};

export const formatPolicyComponentDetailsAssociatedPolicies = (
    simpleDeployedPolicyConfigs: Array<SimpleDeployedPolicyConfig>,
    axnWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNRPServiceWorkflows: Array<SimpleAxnRpServiceWorkflow>,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnCompanies: Array<AxnCompany>,
    axnRpServices: Array<RpServiceConfiguration>
) => {
    const axnRpServiceWorkflowIDs: Array<string> = [];

    const axnRpServicesMap: { [id: string]: RpServiceConfiguration } = toObject(axnRpServices, "id");

    const rpAXNServiceIDs = simpleDeployedPolicyConfigs.map(simpleDeployedPolicyConfig => simpleDeployedPolicyConfig.rpAXNServiceID);

    const axnRpServiceWorkflowsMap = simpleAXNRPServiceWorkflows.reduce((axnRpServiceWorkflowsAcc, simpleAXNRPServiceWorkflow) => {
        if (rpAXNServiceIDs.includes(simpleAXNRPServiceWorkflow.rpAXNServiceID)) {
            axnRpServiceWorkflowsAcc[simpleAXNRPServiceWorkflow.rpAXNServiceID] = simpleAXNRPServiceWorkflow;
            axnRpServiceWorkflowIDs.push(simpleAXNRPServiceWorkflow.workflowID);
        }

        return axnRpServiceWorkflowsAcc;
    }, {} as { [id: string]: SimpleAxnRpServiceWorkflow });

    const workflowsMap = getAxnAdminWorkflowsMap(axnWorkflows, axnRpServiceWorkflowIDs);

    const associatedPolicies: Array<PolicyComponentAssociatedPolicy> = simpleDeployedPolicyConfigs.map((simpleDeployedPolicyConfig, index) => {
        const id = simpleDeployedPolicyConfig.rpAXNServiceID;
        let workflow: SimpleAxnWorkflow = null;
        let relyingParty: AxnRelyingParty = null;
        let organization: AxnCompany = null;
        let serviceName: string = null;
        let serviceApiKey: string = null;

        if (axnRpServiceWorkflowsMap[id]) {
            const axnRpServiceWorkflow = axnRpServiceWorkflowsMap[id];
            if (workflowsMap[axnRpServiceWorkflow.workflowID]) {
                workflow = workflowsMap[axnRpServiceWorkflow.workflowID];
            }
        }

        if (axnRpServicesMap[id]) {
            relyingParty = axnRelyingParties.find(axnRelyingParty => axnRelyingParty.id === axnRpServicesMap[id].relyingPartyID);
            organization = axnCompanies.find(axnCompany => axnCompany.id === relyingParty.companyID);
            serviceName = axnRpServicesMap[id].serviceName;
            serviceApiKey = axnRpServicesMap[id].apiKey;
        }

        return {
            policyID: simpleDeployedPolicyConfigs[index].id,
            serviceName,
            serviceApiKey,
            workflow,
            relyingParty,
            organization
        }
    });

    return associatedPolicies;
};